import { FC, useState } from 'react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import { StatsApi } from '@api/technologies/stats';
import { Avatar, AvatarGroup, Divider, Stack, Typography } from '@mui/material';
import { useGlobalDrawerContext } from '../GlobalDrawer';
import { TechExtendedImpactIndicator } from './ExtendedRiskIndicator';
import { Loading } from '../Loading';
import { ImpactMeta } from '../ImpactIndicator/functions';

export interface TechImpactIndicatorProps {
  tech: string;
  show: boolean;
  impactMeta: ImpactMeta;
}

export const TechImpactIndicator: FC<TechImpactIndicatorProps> = ({
  tech,
  show,
  impactMeta,
}) => {
  const { showDrawer } = useGlobalDrawerContext();

  const [painted, setPainted] = useState<boolean>(false);

  if (!show) return null;

  return (
    <>
      <motion.div
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          borderColor: painted ? '#484848' : null,
          paddingLeft: painted ? 8 : null,
          paddingRight: painted ? 8 : null,
          borderStyle: painted ? 'solid' : null,
        }}
        transition={{ delay: 0.25 }}
        whileHover={{ scale: 1.1 }}
        onClick={(event) => {
          event.stopPropagation();

          showDrawer(
            `loading-tech-impact`,
            (lastId: string, closed: boolean) => {
              if (closed && lastId === `loading-tech-impact`) {
                setPainted(false);
              } else if (lastId !== `loading-tech-impact`) {
                setPainted(false);
              } else {
                setPainted(true);
              }
            },
            <Stack
              spacing={3}
              justifyContent={'center'}
              alignItems={'center'}
              sx={{ px: 2, maxWidth: 400 }}
            >
              <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <Typography variant={'h6'}>
                  Related Technology Impacts
                </Typography>
              </Stack>
              <Divider variant={'middle'} sx={{ width: '100%' }} />
              <Loading />
            </Stack>,
          );
          StatsApi.getTechImpacts(tech).then((res) => {
            showDrawer(
              `${tech}-tech-impact`,
              (lastId: string, closed: boolean) => {
                if (closed && `${tech}-tech-impact` === lastId) {
                  setPainted(false);
                } else if (`${tech}-tech-impact` !== lastId) {
                  setPainted(false);
                } else {
                  setPainted(true);
                }
              },
              <TechExtendedImpactIndicator
                techImpacts={res.data}
                keyword={tech}
              />,
            );
          });
        }}
      >
        {impactMeta && (
          <AvatarGroup max={3}>
            {impactMeta?.map((impactMeta) => (
              <Avatar
                key={impactMeta.level + tech}
                sx={{ backgroundColor: 'black' }}
              >
                <Icon icon={impactMeta.icon} fontSize={40} />
              </Avatar>
            ))}
          </AvatarGroup>
        )}
      </motion.div>
    </>
  );
};
